import React, { memo, Children } from 'react';
import classNames from 'classnames';
import RouteTab from './RouteTab';

import './ThemedRouteTabs.scss';

const ThemedRouteTabs = ({ children, className = '' }) => {
  const classes = classNames('ThemedRouteTabs', className);

  return (
    <div className={classes}>
      {Children.map(children, (child) => (child.type === RouteTab ? child : <></>))}
    </div>
  );
};

export default memo(ThemedRouteTabs);
